export const widgetPlugins = [
  {
    appName: 'Wix Bookings',
    appId: '13d21c63-b5ec-5912-8397-c3a5ddb27a97',
    component: {
      componentId: 'a91a0543-d4bd-4e6b-b315-9410aa27bcde',
      name: 'Service Page',
      data: {
        widgetPlugin: {
          placements: [
            {
              appDefinitionId: '13d21c63-b5ec-5912-8397-c3a5ddb27a97',
              widgetId: 'a91a0543-d4bd-4e6b-b315-9410aa27bcde',
              slotId: 'slot1',
            },
          ],
        },
      },
    },
  },
  {
    appName: 'Wix Events',
    appId: '140603ad-af8d-84a5-2c80-a0f60cb47351',
    component: {
      componentId: '14d2abc2-5350-6322-487d-8c16ff833c8a',
      name: 'Event Details',
      data: {
        widgetPlugin: {
          placements: [
            {
              appDefinitionId: '140603ad-af8d-84a5-2c80-a0f60cb47351',
              widgetId: '14d2abc2-5350-6322-487d-8c16ff833c8a',
              slotId: 'header',
            },
            {
              appDefinitionId: '140603ad-af8d-84a5-2c80-a0f60cb47351',
              widgetId: '14d2abc2-5350-6322-487d-8c16ff833c8a',
              slotId: 'details',
            },
          ],
        },
      },
    },
  },
  {
    appName: 'Wix Stores',
    appId: '1380b703-ce81-ff05-f115-39571d94dfcd',
    component: {
      componentId: 'bda15dc1-816d-4ff3-8dcb-1172d5343cce',
      name: 'Category Page',
      data: {
        widgetPlugin: {
          placements: [
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: 'bda15dc1-816d-4ff3-8dcb-1172d5343cce',
              slotId: 'gallery-products-top',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: 'bda15dc1-816d-4ff3-8dcb-1172d5343cce',
              slotId: 'gallery-products-bottom',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: 'bda15dc1-816d-4ff3-8dcb-1172d5343cce',
              slotId: 'category-page-list-top',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: 'bda15dc1-816d-4ff3-8dcb-1172d5343cce',
              slotId: 'category-page-hero-top',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: 'bda15dc1-816d-4ff3-8dcb-1172d5343cce',
              slotId: 'category-page-hero-bottom',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: 'bda15dc1-816d-4ff3-8dcb-1172d5343cce',
              slotId: 'gallery-filters-top',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: 'bda15dc1-816d-4ff3-8dcb-1172d5343cce',
              slotId: 'gallery-filters-bottom',
            },
          ],
        },
      },
    },
  },
  {
    appName: 'Wix Stores',
    appId: '1380b703-ce81-ff05-f115-39571d94dfcd',
    component: {
      componentId: '13afb094-84f9-739f-44fd-78d036adb028',
      name: 'Gallery widget',
      data: {
        widgetPlugin: {
          placements: [
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13afb094-84f9-739f-44fd-78d036adb028',
              slotId: 'gallery-filters-bottom',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13afb094-84f9-739f-44fd-78d036adb028',
              slotId: 'gallery-filters-top',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13afb094-84f9-739f-44fd-78d036adb028',
              slotId: 'category-page-list-top',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13afb094-84f9-739f-44fd-78d036adb028',
              slotId: 'gallery-products-bottom',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13afb094-84f9-739f-44fd-78d036adb028',
              slotId: 'gallery-products-top',
            },
          ],
        },
      },
    },
  },
  {
    appName: 'Wix Stores',
    appId: 'a0c68605-c2e7-4c8d-9ea1-767f9770e087',
    component: {
      componentId: '6a25b678-53ec-4b37-a190-65fcd1ca1a63',
      name: 'New Product page',
      data: {
        widgetPlugin: {
          placements: [
            {
              appDefinitionId: 'a0c68605-c2e7-4c8d-9ea1-767f9770e087',
              widgetId: '6a25b678-53ec-4b37-a190-65fcd1ca1a63',
              slotId: 'product-page-details-1',
            },
            {
              appDefinitionId: 'a0c68605-c2e7-4c8d-9ea1-767f9770e087',
              widgetId: '6a25b678-53ec-4b37-a190-65fcd1ca1a63',
              slotId: 'product-page-details-2',
            },
            {
              appDefinitionId: 'a0c68605-c2e7-4c8d-9ea1-767f9770e087',
              widgetId: '6a25b678-53ec-4b37-a190-65fcd1ca1a63',
              slotId: 'product-page-details-3',
            },
            {
              appDefinitionId: 'a0c68605-c2e7-4c8d-9ea1-767f9770e087',
              widgetId: '6a25b678-53ec-4b37-a190-65fcd1ca1a63',
              slotId: 'product-page-details-4',
            },
            {
              appDefinitionId: 'a0c68605-c2e7-4c8d-9ea1-767f9770e087',
              widgetId: '6a25b678-53ec-4b37-a190-65fcd1ca1a63',
              slotId: 'product-page-details-5',
            },
            {
              appDefinitionId: 'a0c68605-c2e7-4c8d-9ea1-767f9770e087',
              widgetId: '6a25b678-53ec-4b37-a190-65fcd1ca1a63',
              slotId: 'product-page-details-6',
            },
            {
              appDefinitionId: 'a0c68605-c2e7-4c8d-9ea1-767f9770e087',
              widgetId: '6a25b678-53ec-4b37-a190-65fcd1ca1a63',
              slotId: 'product-page-details-7',
            },
            {
              appDefinitionId: 'a0c68605-c2e7-4c8d-9ea1-767f9770e087',
              widgetId: '6a25b678-53ec-4b37-a190-65fcd1ca1a63',
              slotId: 'product-page-details-8',
            },
            {
              appDefinitionId: 'a0c68605-c2e7-4c8d-9ea1-767f9770e087',
              widgetId: '6a25b678-53ec-4b37-a190-65fcd1ca1a63',
              slotId: 'product-page-details-9',
            },
            {
              appDefinitionId: 'a0c68605-c2e7-4c8d-9ea1-767f9770e087',
              widgetId: '6a25b678-53ec-4b37-a190-65fcd1ca1a63',
              slotId: 'product-page-bottom',
            },
            {
              appDefinitionId: 'a0c68605-c2e7-4c8d-9ea1-767f9770e087',
              widgetId: '6a25b678-53ec-4b37-a190-65fcd1ca1a63',
              slotId: 'product-page-top',
            },
            {
              appDefinitionId: 'a0c68605-c2e7-4c8d-9ea1-767f9770e087',
              widgetId: '6a25b678-53ec-4b37-a190-65fcd1ca1a63',
              slotId: 'product-page-media-1',
            },
          ],
        },
      },
    },
  },
  {
    appName: 'Wix Stores',
    appId: '1380b703-ce81-ff05-f115-39571d94dfcd',
    component: {
      componentId: '13a94f09-2766-3c40-4a32-8edb5acdd8bc',
      name: 'Old Product page',
      data: {
        widgetPlugin: {
          placements: [
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13a94f09-2766-3c40-4a32-8edb5acdd8bc',
              slotId: 'product-page-details-1',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13a94f09-2766-3c40-4a32-8edb5acdd8bc',
              slotId: 'product-page-details-2',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13a94f09-2766-3c40-4a32-8edb5acdd8bc',
              slotId: 'product-page-details-3',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13a94f09-2766-3c40-4a32-8edb5acdd8bc',
              slotId: 'product-page-details-4',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13a94f09-2766-3c40-4a32-8edb5acdd8bc',
              slotId: 'product-page-details-5',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13a94f09-2766-3c40-4a32-8edb5acdd8bc',
              slotId: 'product-page-details-6',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13a94f09-2766-3c40-4a32-8edb5acdd8bc',
              slotId: 'product-page-details-7',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13a94f09-2766-3c40-4a32-8edb5acdd8bc',
              slotId: 'product-page-details-8',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13a94f09-2766-3c40-4a32-8edb5acdd8bc',
              slotId: 'product-page-details-9',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13a94f09-2766-3c40-4a32-8edb5acdd8bc',
              slotId: 'product-page-top',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13a94f09-2766-3c40-4a32-8edb5acdd8bc',
              slotId: 'product-page-bottom',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13a94f09-2766-3c40-4a32-8edb5acdd8bc',
              slotId: 'product-page-media-1',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '13a94f09-2766-3c40-4a32-8edb5acdd8bc',
              slotId: 'product-page-additional-buttons',
            },
          ],
        },
      },
    },
  },
  {
    appName: 'Checkout & Orders',
    appId: '1380b703-ce81-ff05-f115-39571d94dfcd',
    component: {
      componentId: '14fd5970-8072-c276-1246-058b79e70c1a',
      name: 'Checkout',
      data: {
        widgetPlugin: {
          placements: [
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '14fd5970-8072-c276-1246-058b79e70c1a',
              slotId: 'checkout:top',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '14fd5970-8072-c276-1246-058b79e70c1a',
              slotId: 'checkout:header',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '14fd5970-8072-c276-1246-058b79e70c1a',
              slotId: 'checkout:summary:before',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '14fd5970-8072-c276-1246-058b79e70c1a',
              slotId: 'checkout:summary:after',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '14fd5970-8072-c276-1246-058b79e70c1a',
              slotId: 'checkout:summary:lineItems:after',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '14fd5970-8072-c276-1246-058b79e70c1a',
              slotId: 'checkout:summary:lineItems:after2',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '14fd5970-8072-c276-1246-058b79e70c1a',
              slotId: 'checkout:summary:totalsBreakdown:before',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '14fd5970-8072-c276-1246-058b79e70c1a',
              slotId: 'checkout:steps:before',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '14fd5970-8072-c276-1246-058b79e70c1a',
              slotId: 'checkout:steps:deliveryMethod',
            },
          ],
        },
      },
    },
  },
  {
    appName: 'Checkout & Orders',
    appId: '1380b703-ce81-ff05-f115-39571d94dfcd',
    component: {
      componentId: '49dbb2d9-d9e5-4605-a147-e926605bf164',
      name: 'SideCart',
      data: {
        widgetPlugin: {
          placements: [
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '49dbb2d9-d9e5-4605-a147-e926605bf164',
              slotId: 'side-cart:header:after-1',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '49dbb2d9-d9e5-4605-a147-e926605bf164',
              slotId: 'side-cart:line-items:after-1',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '49dbb2d9-d9e5-4605-a147-e926605bf164',
              slotId: 'side-cart:customer-input:after-1',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '49dbb2d9-d9e5-4605-a147-e926605bf164',
              slotId: 'side-cart:footer:actions:before-1',
            },
            {
              appDefinitionId: '1380b703-ce81-ff05-f115-39571d94dfcd',
              widgetId: '49dbb2d9-d9e5-4605-a147-e926605bf164',
              slotId: 'side-cart:footer:actions:after-1',
            },
          ],
        },
      },
    },
  },
  {
    appName: 'Wix Blog',
    appId: '14bcded7-0066-7c35-14d7-466cb3f09103',
    component: {
      componentId: '211b5287-14e2-4690-bb71-525908938c81',
      name: 'Post Page',
      data: {
        widgetPlugin: {
          placements: [
            {
              appDefinitionId: '14bcded7-0066-7c35-14d7-466cb3f09103',
              widgetId: '211b5287-14e2-4690-bb71-525908938c81',
              slotId: 'above-header',
            },
            {
              appDefinitionId: '14bcded7-0066-7c35-14d7-466cb3f09103',
              widgetId: '211b5287-14e2-4690-bb71-525908938c81',
              slotId: 'above-content-1',
            },
            {
              appDefinitionId: '14bcded7-0066-7c35-14d7-466cb3f09103',
              widgetId: '211b5287-14e2-4690-bb71-525908938c81',
              slotId: 'above-content-2',
            },
            {
              appDefinitionId: '14bcded7-0066-7c35-14d7-466cb3f09103',
              widgetId: '211b5287-14e2-4690-bb71-525908938c81',
              slotId: 'below-content-1',
            },
            {
              appDefinitionId: '14bcded7-0066-7c35-14d7-466cb3f09103',
              widgetId: '211b5287-14e2-4690-bb71-525908938c81',
              slotId: 'below-content-2',
            },
            {
              appDefinitionId: '14bcded7-0066-7c35-14d7-466cb3f09103',
              widgetId: '211b5287-14e2-4690-bb71-525908938c81',
              slotId: 'page-bottom-1',
            },
            {
              appDefinitionId: '14bcded7-0066-7c35-14d7-466cb3f09103',
              widgetId: '211b5287-14e2-4690-bb71-525908938c81',
              slotId: 'page-bottom-2',
            },
            {
              appDefinitionId: '14bcded7-0066-7c35-14d7-466cb3f09103',
              widgetId: '211b5287-14e2-4690-bb71-525908938c81',
              slotId: 'page-bottom-3',
            },
          ],
        },
      },
    },
  },
];
